var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 131.24 260.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.21 99.95V31.54c0-5.73-2.35-10.94-6.13-14.73-3.78-3.78-9-6.13-14.73-6.13s-10.94 2.35-14.73 6.13c-3.78 3.79-6.13 9-6.13 14.73V163.1c-14.45 7.41-24.33 22.46-24.33 39.82 0 24.69 20.01 44.71 44.71 44.71s44.72-20.02 44.72-44.71c0-16.97-9.45-31.73-23.38-39.31V99.95zm-12.23 71.36c13.73 3.95 23.78 16.6 23.78 31.61 0 18.16-14.72 32.88-32.89 32.88-18.16 0-32.89-14.72-32.89-32.88 0-15.01 10.05-27.66 23.79-31.61V55.52c0-11.31 18.21-10.86 18.21 0v115.79zm34.19-134.88v-9.68h25.23c2.67 0 4.84 2.16 4.84 4.84 0 2.67-2.17 4.84-4.84 4.84h-25.23zm0 26.43v-9.68h25.23c2.67 0 4.84 2.17 4.84 4.84s-2.17 4.84-4.84 4.84h-25.23zm0 26.43v-9.68h25.23c2.67 0 4.84 2.17 4.84 4.84s-2.17 4.84-4.84 4.84h-25.23zm0 26.43v-9.68h25.23c2.67 0 4.84 2.17 4.84 4.84s-2.17 4.84-4.84 4.84h-25.23zm0 26.43v-9.68h25.23c2.67 0 4.84 2.17 4.84 4.84 0 2.68-2.17 4.84-4.84 4.84h-25.23zM89.9 154.71c15.58 10.37 25.84 28.09 25.84 48.21 0 31.96-25.91 57.87-57.87 57.87C25.91 260.79 0 234.88 0 202.92c0-20.53 10.69-38.57 26.81-48.84V31.54c0-8.68 3.55-16.56 9.26-22.28C41.79 3.55 49.67 0 58.35 0c8.68 0 16.57 3.55 22.28 9.26 5.72 5.72 9.27 13.6 9.27 22.28v123.17z",
    fill: "#022449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.c72763ba131dff9233dd862f565db3f9.svg";
export { ForwardRef as ReactComponent };